import { useService } from 'react-reservice';

import countryService from './service';

export const useCountry = () => {
  return useService(countryService, (state) => state);
};

export { countryService };
